// src/store/thunks/courseThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../remote/apiService';
import { fetchCoursesStart, fetchCoursesSuccess, fetchCoursesFailure } from '../slices/coursesSlice';

export const fetchCourses = createAsyncThunk(
    'navigation/fetchCourses',
    async (_, { dispatch }) => {
        dispatch(fetchCoursesStart());
        try {
            const response = await apiService.getCourses();
            if (response.code === 200) {
                dispatch(fetchCoursesSuccess(response.data));
            } else {
                dispatch(fetchCoursesFailure(response.message));
            }
        } catch (error) {
            if (error instanceof Error) {
                dispatch(fetchCoursesFailure(error.message || '获取课程数据失败'));
            } else {
                dispatch(fetchCoursesFailure('发生未知错误'));
            }
        }
    }
);